const initialState = {
  user: null,
  loading: false,
  error: null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_USER_PROFILE_START':
      return { ...state, loading: true, error: null };

    case 'FETCH_USER_PROFILE_SUCCESS':
      return {
        ...state,
        loading: false,
        user: action.payload.user,
        error: null
      };

    case 'FETCH_USER_PROFILE_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'UPDATE_USER_SUCCESS':
      return {
        ...state,
        user: { ...state.user, ...action.payload }
      };

    case 'LOGOUT_START':
      return { ...state, loading: true, error: null };

    case 'LOGOUT_SUCCESS':
      return initialState;

    case 'LOGOUT_FAILURE':
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default authReducer;